interface StateType {
    mainBackground: string;
    bottomBackground: string;
    middleBackground: string;
    listBackground: string;
}
type stateKey = keyof StateType;

interface PayloadType {
    key: stateKey;
    value: string;
}

export default {
    state: {
        mainBackground: '',
        bottomBackground: '',
        middleBackground: '',
        listBackground: ''
    },
    mutations: {
        setBackgrondValue(state: StateType, playLoad: PayloadType) {
            const { key, value } = playLoad;
            if (state[key]) return;
            state[key] = value;
        }
    },

    namespaced: true
};
